export const VARIANTS = ['apple', 'facebook', 'google'] as const;

export const VARIANT: Record<
typeof VARIANTS[number],
{
  icon: string
}
> = {
  apple: {
    icon: '/assets/icons/apple_icon.svg'
  },
  facebook: {
    icon: '/assets/icons/facebook_icon.svg'
  },
  google: {
    icon: '/assets/icons/google_icon.svg'
  }
}